
import { chooseFile } from '../common/js/utils';
import { Request } from '../common/js/request';
import { T } from '../common/js/i18n';
import { genRsaKeyPair, RsaPriKey2048, Bytes } from '../common/js/crypto';
import { setLogined } from '../store/index';

export async function loginBySignature(publicKey: string, privateKey: string) {
    let api = "/api/user/loginBySignature";
    let signature = RsaPriKey2048.tryFromString(privateKey).sign(Bytes.fromUtf8(publicKey + api));
    await new Request(api).call({
        public_key: publicKey,
        signature: signature?.toBase64(),
    });
    setLogined(true, {
        publicKey: publicKey,
        privateKey: privateKey
    });
}

interface Props {
    onDone: () => void;
}

export default function Login(props: Props) {
    return (
        <div>
            <div style={{ textAlign: "center", marginTop: "1em" }}>
                <button type="button" className="btn" onClick={() => {
                    chooseFile(async (files) => {
                        let file = files[0];
                        if ("application/json" !== file.type || 1024 * 1024 < file.size) {
                            alert(T({ en: "Not a account file!", zh: "选择的不是账户文件!" }));
                        } else {
                            let content = await file.text();
                            let keyPair = JSON.parse(content);
                            await loginBySignature(keyPair["publicKey"], keyPair["privateKey"]);
                            localStorage.setItem("keyPair", content);
                            props.onDone();
                        }
                    });
                }}>{T({ en: "Log in by loading account file", zh: "选择账户文件登录" })}</button>
                <button type="button" className="btn" style={{ marginLeft: "1em" }} onClick={async () => {
                    let keyPair = genRsaKeyPair();
                    let publicKey = keyPair["public"].getString();
                    let privateKey = keyPair["private"].getString();
                    await loginBySignature(publicKey, privateKey);
                    localStorage.setItem("keyPair", JSON.stringify({
                        publicKey: publicKey,
                        privateKey: privateKey,
                    }));
                    props.onDone();
                }}>{T({ en: "Log in by random account", zh: "随机账户登录" })}</button>
            </div>
        </div>
    );
}
